import moment from 'moment'
import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const defaultMaxTime = moment().endOf('day').toDate()

export default class DateTimePickerReactTz extends React.Component {
  handleChange = d => {
    const { onChange } = this.props

    onChange(d)
  }

  render() {
    const {
      size,
      className,
      loading,
      active,
      id,
      hint,
      hintClass,
      label,
      placeholder,
      value,
      onChange,
      children,
      disabled,
      timestamp,
      minDate,
      minTime,
      maxTime,
      timezone,
      ...input
    } = this.props
    const { error, touched } = input
    const hasError = error && touched
    const before = []
    const after = []

    let hintNode = null
    const hintNodeId = id ? `${id}_hint` : ''
    if (hint) {
      hintNode = (
        <small id={hintNodeId} className={`hint ${hintClass || ''}`}>
          {hint}
        </small>
      )
    }

    return (
      <div>
        <div>
          {!!before.length && <div className="floating-field-addons">{before}</div>}
          <div>
            {label ? (
              <label
                htmlFor={id}
                className="control-label"
                style={{ fontSize: 12, fontWeight: 600, color: '#c6cbd0', cursor: 'pointer' }}
              >
                {label}
              </label>
            ) : null}
            <div style={{ position: 'relative' }}>
              {hasError ? <div className="error-block-datepicker">{error}</div> : null}
            </div>
            <DatePicker
              disabled={disabled}
              selected={value ? new Date(value) : ''}
              onSelect={d => this.handleChange(d, true)}
              onChange={this.handleChange}
              id={id}
              autoComplete="off"
              dateFormat={'d MMM yyyy h:mm a'}
              showTimeSelect={true}
              placeholderText={placeholder}
              minDate={new Date(minDate)}
              minTime={minTime ? new Date(minTime) : null}
              maxTime={minTime ? maxTime || defaultMaxTime : null}
            />
          </div>
          {!!after.length && <div className="floating-field-addons">{after}</div>}
        </div>
        {hintNode}
      </div>
    )
  }
}
